import request from "@/utils/request"

export default (body, product) => {
  const url = `/api/purchases/${product}`
  return request.post(url, {
    body,
    token: true
  })
}
